import React, {useState, useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import parse from 'html-react-parser';
import { FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';

import { List, Spin, Avatar, Empty } from 'antd';
import InfiniteScroll from "react-infinite-scroller";

import  ListCloseIcon from '../listComponents/listCloseIcon';
import CloseButton from '../../../Utility/closeButton';

import userAPI from '../../../../API/user.service.api';


const NotificationList = (props) => {
    const history = useHistory();
    const { user={} } = useSelector(store => store.authentication);
    const { router } = useSelector(store => store);
    const { notificationItem, dataNotifi } = props;
    const [data, setData] = useState([...dataNotifi]);
    const [isLoadMoreAvailable, setIsLoadMoreAvailable] = useState(false);
    const [handlerLoading, setHandlerLoading] = useState(false);

    const listText = {
        emptyText: <Empty description={<FormattedMessage id='No Data' defaultMessage='No Data'/>} image={Empty.PRESENTED_IMAGE_SIMPLE}/>
    }

    useEffect(() => {
        loadMore(1);
    },[]);

    useEffect(() => {
        return history.listen((location) => {
            props.setShow(false);
        });
    }, [history])


    const loadMore = (page) => {
        setHandlerLoading(true);
        userAPI.getHistoryById(user.id, page)
        .then(res => {
            const {code, history, currentPage, isLoadMoreAvailable} = res;
            if(code === 200){
                setData([...data, ...history]);
                setIsLoadMoreAvailable(isLoadMoreAvailable);
            }
            setHandlerLoading(false);
        })
        .catch(err => {
            console.log(err);
            setHandlerLoading(false);
        })
    }

    const style={
        position: 'absolute',
        width: 400,
        zIndex: 2000,
        right: -10,
        maxHeight: '100vh',
        top: 50
    }

    const today = new Date();
    const todayFullDate = getDateString(today);
    
    return(
        <div className="listLayout notification" style={style}>
            <div className="listGreenLine">
            <div className="label">
                <FormattedMessage id="Notification" defaultMessage="Notification"/>
            </div>
            <div className="rightIcon">
                <CloseButton close={props.closeFunc}/> 
            </div>
            </div>
            <div className="listContent" style={{overflowY: "auto", maxHeight: '91vh', minHeight: 200}}>
                <InfiniteScroll
                    pageStart={1}
                    loadMore={(page) => loadMore(page)}
                    hasMore={isLoadMoreAvailable}
                    loader={
                        <div
                            className="loader"
                            key={0}
                            style={{
                                width: "100%",
                                height: "40px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Spin />
                        </div>
                    }
                    useWindow={false}
                >
                    <List
                        dataSource={data}
                        itemLayout="horizontal"
                        renderItem={(item, i) => {
                            const { date, time } = parseDateAndTime(item.created_at);

                            if(item.type && item.entity){
                                return notificationItem(item, i, true)
                            }else{
                                return(
                                    <List.Item key={item.id}>
                                        <div className="item_notifi">
                                            <div className="avatar">
                                                <Avatar
                                                    src={process.env.BACKEND_URL + item.logo}
                                                    icon='camera'
                                                    size={80}
                                                />
                                            </div>
                                            <div className="item_notifi_body">
                                                <div className="item_header">
                                                    <div className="name">
                                                        {parse(item.name)}
                                                    </div>
                                                    <div className="date-time">
                                                        {date === todayFullDate ? 
                                                            <FormattedTime value={createTodayTime(time)} /> : 
                                                            date && <FormattedDate value={date} />
                                                        }
                                                    </div>
                                                </div>
                                                <div className="message">{parse(item.message)}</div>
                                                {item.images ? (
                                                    <div className="pictures">
                                                        {item.images.map(img => img.picture ? <img key={img.picture} src={img.picture} style={{width: 50, height: 50}}/> : null)}
                                                    </div>
                                                    ) 
                                                    :  
                                                    ( null ) 
                                                }
                                            </div>
                                        </div>
                                    </List.Item>
                                )
                            }
                        }}
                        loading={handlerLoading}
                        locale={listText}
                    >
                    </List>
                </InfiniteScroll>
            </div>
        </div>
    )
}


function getDateString(date) {
    return `${date.getFullYear()}-${
        date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
    }-${date.getDate()}`;
}

function parseDateAndTime(timestring) {
    const [date, time] = timestring?.split(' ') || [null, ''];
    return { date, time };
}

function createTodayTime(timeString) {
    const [hh, mm, ss] = timeString.split(':');
    return new Date().setHours(+hh, +mm, +ss, 0);
}


export default NotificationList;